import React, { memo, useContext } from "react";
import { Handle, Position } from "reactflow";
import Context from "../Contex/Context";
import img from '../Images/add-circle.png'
import pinkPlus from '../Images/Add_Plus_Circle.svg';
import grayPlus from '../Images/GrayPuls.svg';
export default function CustomNode(node) {
  const { allNodes, hoveredNode, allEdges,erroredNode } = useContext(Context);
  const handleEvent = node.data.handleEvent;
  const handleEvent2=node.data.handleEvent2
  const customIconStyle = {
    height:'25px',
    width:'25px',
    top:'90%',
    backgroundImage: `url(${img})`, // Replace with the actual path to your custom icon
    backgroundSize: 'cover', // Adjust the background size as needed
  };
 

  return (
    <div>
      {node.data.label === "Start" && (
        <>
          <div className="startcampaignstyle">Start</div>
         
         <Handle
         onClick={()=>{
           handleEvent2(node)
         }}
         type="source"
         position={Position.Bottom}
         className="w-16 !bg-teal-500 custom-handle"
          style={{
            height:'25px',
            width:'25px',
            top:'90%',
            backgroundImage: `url(${allEdges.some(obj => obj.source === node.id)?grayPlus:pinkPlus})`, // Replace with the actual path to your custom icon
            backgroundSize: 'cover', 
            opacity:allEdges.some(obj => obj.source === node.id)&&'0.4',
            pointerEvents:allEdges.some(obj => obj.source === node.id)&&'none'
          }}
          
       />  
       
         
        </>
      )}
      {node.data.label === "email" && (
        <div>
          <div
            className="emaildropdownContainer"
            style={{
              background:
                hoveredNode.id === node.id
                  ? "var(--color-primary-100, #D1DFE9)"
                  : "var(--color-white, #fff)",
              border:
              erroredNode.some(obj => obj.id === node.id)?"1px solid red":
                hoveredNode.id === node.id &&
                "1px solid var(--color-dark-600, #727272)",
            }}
          >
            {hoveredNode.id === node.id && (
              <svg
                onClick={() => {
                  handleEvent(allNodes, node, allEdges, "delete",false);
                }}
                style={{
                  position: "absolute",
                  left: "100%",
                  marginTop: "-9px",
                  marginLeft: "8px",
                }}
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="26"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.08301 5.10238L7.26634 4.01071C7.39967 3.21905 7.49967 2.62738 8.90801 2.62738H11.0913C12.4997 2.62738 12.608 3.25238 12.733 4.01905L12.9163 5.10238"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.7087 8.57733L15.167 16.969C15.0753 18.2773 15.0003 19.294 12.6753 19.294H7.32533C5.00033 19.294 4.92533 18.2773 4.83366 16.969L4.29199 8.57733"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.6084 14.7107H11.3834"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M7.91699 11.3774H12.0837"
                  stroke="#FF3434"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            )}

            <div
              onClick={() => {
                handleEvent(allNodes, node, allEdges, "open",false);
              }}
              className="emaildropinside"
            >
              <div className="emailboxwithname">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                >
                  <path
                    d="M2.5 8.50073C2.5 5.00073 4.5 3.50073 7.5 3.50073H17.5C20.5 3.50073 22.5 5.00073 22.5 8.50073V15.5007C22.5 19.0007 20.5 20.5007 17.5 20.5007H7.5"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M17.5 9.00073L14.37 11.5007C13.34 12.3207 11.65 12.3207 10.62 11.5007L7.5 9.00073"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.5 16.5007H8.5"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M2.5 12.5007H5.5"
                    stroke="#1C485F"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                Email
              </div>
              {allNodes.map((val) => {
                if (val.id === node.id) {
                  if (val.BackendData !== undefined) {
                    return (
                      <div className="editemailcontentfield">
                        Edit Email content
                      </div>
                    );
                  } else {
                    return (
                      <div className="addemailcontentfield">
                        Add email content
                      </div>
                    );
                  }
                }
              })}
            </div>
          </div>
          <Handle
            type="target"
            position={Position.Top}
            className="w-16 !bg-teal-500"
          />
          <Handle
            type="source"
            position={Position.Bottom}
            className="w-16 !bg-teal-500 custom-handle"
            style={{
              height:'25px',
              width:'25px',
              top:'90%',
              backgroundImage: `url(${allEdges.some(obj => obj.source === node.id)?grayPlus:pinkPlus})`, // Replace with the actual path to your custom icon
              backgroundSize: 'cover', 
              opacity:allEdges.some(obj => obj.source === node.id)&&'0.4',
              pointerEvents:allEdges.some(obj => obj.source === node.id)&&'none'
            }}
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "delete",true);
            }}
          />
        </div>
      )}
      {node.data.label === "Trigger" && (
        <div
          className="triggerboxcontainer"
          style={{
            background:
              hoveredNode.id === node.id
                ? "var(--color-primary-100, #D1DFE9)"
                : "var(--color-white, #fff)",
                border:
                erroredNode.some(obj => obj.id === node.id)?"1px solid red":
                  hoveredNode.id === node.id &&
                  "1px solid var(--color-dark-600, #727272)",
          }}
        >
          {hoveredNode.id === node.id && (
            <svg
              onClick={() => {
                handleEvent(allNodes, node, allEdges, "delete",false);
              }}
              style={{
                position: "absolute",
                left: "100%",
                marginTop: "-9px",
                marginLeft: "8px",
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="26"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.08301 5.10238L7.26634 4.01071C7.39967 3.21905 7.49967 2.62738 8.90801 2.62738H11.0913C12.4997 2.62738 12.608 3.25238 12.733 4.01905L12.9163 5.10238"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.7087 8.57733L15.167 16.969C15.0753 18.2773 15.0003 19.294 12.6753 19.294H7.32533C5.00033 19.294 4.92533 18.2773 4.83366 16.969L4.29199 8.57733"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.6084 14.7107H11.3834"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.91699 11.3774H12.0837"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
          <div
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "open",false);
            }}
            className="triggerinsidebox"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M5.5 9V16"
                stroke="#1C485F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.75 8.5C7.54493 8.5 9 7.04493 9 5.25C9 3.45507 7.54493 2 5.75 2C3.95507 2 2.5 3.45507 2.5 5.25C2.5 7.04493 3.95507 8.5 5.75 8.5Z"
                stroke="#1C485F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.5 22C7.15685 22 8.5 20.6569 8.5 19C8.5 17.3431 7.15685 16 5.5 16C3.84315 16 2.5 17.3431 2.5 19C2.5 20.6569 3.84315 22 5.5 22Z"
                stroke="#1C485F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M19.5 22C21.1569 22 22.5 20.6569 22.5 19C22.5 17.3431 21.1569 16 19.5 16C17.8431 16 16.5 17.3431 16.5 19C16.5 20.6569 17.8431 22 19.5 22Z"
                stroke="#1C485F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M5.62891 9C6.07891 10.75 7.67891 12.05 9.56891 12.04L12.9989 12.03C15.6189 12.02 17.8489 13.7 18.6689 16.04"
                stroke="#1C485F"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div className="triggertext">Trigger</div>
            {allNodes.map((val) => {
              if (val.id === node.id) {
                if (val.BackendData !== undefined) {
                  return (
                    <>
                      <div className="settriggeroption">
                        {val.BackendData.data.trigger === "opened"
                          ? "Opened Email"
                          : val.BackendData.data.trigger === "Clicked"
                          ? "Clicked On a link"
                          : "Booked a meeting via Calendly"}
                      </div>
                      {/* <div className="settriggeroption">
                        Wait up to {val.BackendData.data.waitingTime.count}{" "}
                        {val.BackendData.data.waitingTime.type}{" "}
                      </div> */}
                    </>
                  );
                } else {
                  return (
                    <>
                      <div className="settriggeroption">Set a trigger</div>
                      {/* <div className="settriggeroption">Set waiting time</div> */}
                    </>
                  );
                }
              }
            })}

            <div className="yesornobox">
              <div>No</div>
              <div>Yes</div>
            </div>
          </div>
          <Handle
            type="target"
            position={Position.Top}
            className="w-16 bg-teal-500"
          />
          <Handle
            type="source"
            position={Position.Bottom}
            className="w-16 custom-handle"
            id="a"
            style={{
              background: "#1C485F",
              position: "absolute",
              left: "43px",
              height:'25px',
              width:'25px',
              top:'90%',
              backgroundImage: `url(${allEdges.some(obj => (obj.source === node.id&&obj.sourceHandle==='a'))?grayPlus:pinkPlus})`,
               // Replace with the actual path to your custom icon
              backgroundSize: 'cover',
              opacity:allEdges.some(obj => (obj.source === node.id&&obj.sourceHandle==='a'))&&'0.4',
              pointerEvents:allEdges.some(obj => (obj.source === node.id&&obj.sourceHandle==='a'))&&'none'
            }}
            isConnectable
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "delete",true,'a');
            }}
          />
          <Handle
            type="source"
            position={Position.Bottom}
            className="w-16 custom-handle"
            id="b"
            isConnectable
            style={{ background: "black", position: "absolute", left: "186px", height:'25px',width:'25px',
            top:'90%',
            backgroundImage: `url(${allEdges.some(obj => (obj.source === node.id&&obj.sourceHandle==='b'))?grayPlus:pinkPlus})`,
            backgroundSize: 'cover',
            opacity:allEdges.some(obj => (obj.source === node.id&&obj.sourceHandle==='b'))&&'0.4',
              pointerEvents:allEdges.some(obj => (obj.source === node.id&&obj.sourceHandle==='b'))&&'none'
           }}
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "delete",true,'b');
            }}
          />
        </div>
      )}
      {node.data.label === "Delay" && (
        <div
          className="delaybox"
          style={{
            background:
              hoveredNode.id === node.id
                ? "var(--color-primary-100, #D1DFE9)"
                : "var(--color-white, #fff)",
                border:
                erroredNode.some(obj => obj.id === node.id)?"1px solid red":
                  hoveredNode.id === node.id &&
                  "1px solid var(--color-dark-600, #727272)",
          }}
        >
          {hoveredNode.id === node.id && (
            <svg
              onClick={() => {
                handleEvent(allNodes, node, allEdges, "delete",false);
              }}
              style={{
                position: "absolute",
                left: "100%",
                marginTop: "-9px",
                marginLeft: "8px",
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="26"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.08301 5.10238L7.26634 4.01071C7.39967 3.21905 7.49967 2.62738 8.90801 2.62738H11.0913C12.4997 2.62738 12.608 3.25238 12.733 4.01905L12.9163 5.10238"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.7087 8.57733L15.167 16.969C15.0753 18.2773 15.0003 19.294 12.6753 19.294H7.32533C5.00033 19.294 4.92533 18.2773 4.83366 16.969L4.29199 8.57733"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.6084 14.7107H11.3834"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.91699 11.3774H12.0837"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
          <div
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "open",false);
            }}
            className="delayinsidebox"
          >
            <div className="delayiconname">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20.75 13.25C20.75 18.08 16.83 22 12 22C7.17 22 3.25 18.08 3.25 13.25C3.25 8.42 7.17 4.5 12 4.5C16.83 4.5 20.75 8.42 20.75 13.25Z"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 8V13"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9 2H15"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-miterlimit="10"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Delay
            </div>
            {allNodes.map((val) => {
              if (val.id === node.id) {
                if (val.BackendData !== undefined) {
                  return (
                    <div className="delaywaitingtime">
                      Wait up to {val.BackendData.data.count}{" "}
                      {val.BackendData.data.type}{" "}
                    </div>
                  );
                } else {
                  return (
                    <div className="delaywaitingtime">Set waiting time</div>
                  );
                }
              }
            })}
          </div>
          <Handle
            type="target"
            position={Position.Top}
            className="w-16 !bg-teal-500"
          />
          <Handle
            type="source"
            position={Position.Bottom}
            className="w-16 !bg-teal-500 custom-handle"
            style={{
              height:'25px',
              width:'25px',
              top:'90%',
              backgroundImage: `url(${allEdges.some(obj => obj.source === node.id)?grayPlus:pinkPlus})`, // Replace with the actual path to your custom icon
              backgroundSize: 'cover', 
              opacity:allEdges.some(obj => obj.source === node.id)&&'0.4',
              pointerEvents:allEdges.some(obj => obj.source === node.id)&&'none'
            }}
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "delete",true);
            }}
          />
        </div>
      )}
      {node.data.label === "Goal" && (
        <div
          className="goalbox"
          style={{
            background:
              hoveredNode.id === node.id
                ? "var(--color-primary-100, #D1DFE9)"
                : "var(--color-white, #fff)",
                border:
                erroredNode.some(obj => obj.id === node.id)?"1px solid red":
                  hoveredNode.id === node.id &&
                  "1px solid var(--color-dark-600, #727272)",
          }}
        >
          {hoveredNode.id === node.id && (
            <svg
              onClick={() => {
                handleEvent(allNodes, node, allEdges, "delete");
              }}
              style={{
                position: "absolute",
                left: "100%",
                marginTop: "-9px",
                marginLeft: "8px",
              }}
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="26"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M17.5 5.94401C14.725 5.66901 11.9333 5.52734 9.15 5.52734C7.5 5.52734 5.85 5.61068 4.2 5.77734L2.5 5.94401"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.08301 5.10238L7.26634 4.01071C7.39967 3.21905 7.49967 2.62738 8.90801 2.62738H11.0913C12.4997 2.62738 12.608 3.25238 12.733 4.01905L12.9163 5.10238"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M15.7087 8.57733L15.167 16.969C15.0753 18.2773 15.0003 19.294 12.6753 19.294H7.32533C5.00033 19.294 4.92533 18.2773 4.83366 16.969L4.29199 8.57733"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M8.6084 14.7107H11.3834"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.91699 11.3774H12.0837"
                stroke="#FF3434"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          )}
          <div
            onClick={() => {
              handleEvent(allNodes, node, allEdges, "open",false);
            }}
            className="goalboxinside"
          >
            <div className="goalboxiconname">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M4.26172 11.02V15.99C4.26172 17.81 4.26172 17.81 5.98172 18.97L10.7117 21.7C11.4217 22.11 12.5817 22.11 13.2917 21.7L18.0217 18.97C19.7417 17.81 19.7417 17.81 19.7417 15.99V11.02C19.7417 9.2 19.7417 9.2 18.0217 8.04L13.2917 5.31C12.5817 4.9 11.4217 4.9 10.7117 5.31L5.98172 8.04C4.26172 9.2 4.26172 9.2 4.26172 11.02Z"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M17.5 7.63V5C17.5 3 16.5 2 14.5 2H9.5C7.5 2 6.5 3 6.5 5V7.56"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12.6317 10.99L13.2017 11.88C13.2917 12.02 13.4917 12.16 13.6417 12.2L14.6617 12.46C15.2917 12.62 15.4617 13.16 15.0517 13.66L14.3817 14.47C14.2817 14.6 14.2017 14.83 14.2117 14.99L14.2717 16.04C14.3117 16.69 13.8517 17.02 13.2517 16.78L12.2717 16.39C12.1217 16.33 11.8717 16.33 11.7217 16.39L10.7417 16.78C10.1417 17.02 9.68173 16.68 9.72173 16.04L9.78173 14.99C9.79173 14.83 9.71173 14.59 9.61173 14.47L8.94173 13.66C8.53173 13.16 8.70173 12.62 9.33173 12.46L10.3517 12.2C10.5117 12.16 10.7117 12.01 10.7917 11.88L11.3617 10.99C11.7217 10.45 12.2817 10.45 12.6317 10.99Z"
                  stroke="#1C485F"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              Goal
            </div>
            {allNodes.map((val) => {
              if (val.id === node.id) {
                if (val.BackendData !== undefined) {
                  return (
                    <div className="golboxtextinside">
                      {val.BackendData.data.goalName}{" "}
                    </div>
                  );
                } else {
                  return (
                    <div className="golboxtextinside">Define goal name</div>
                  );
                }
              }
            })}
          </div>
          <Handle
            type="target"
            position={Position.Top}
            className="w-16 !bg-teal-500"
          />
        </div>
      )}
    </div>
  );
}
